import {withShade} from '@dropbox/dig-foundations';
import {growthbookCacheAtom} from 'atoms/growthbook';
import {useSkeletonFadeIn} from 'components/DSYS/SkeletonFadeIn';
import {ROUTE_PATHS} from 'constant';
import {useAtomValue} from 'jotai';
import {DashboardState} from 'views/home/dashboard/dashboardModel';
import {Tile} from 'views/home/dashboard/Tile';
import {TileHeaderLink} from 'views/home/dashboard/TileListFooter';
import {TileRowLink} from 'views/home/dashboard/TileRowLink';
import {NewArrivalPersonRow} from 'views/home/dashboard/tiles/NewArrivalPersonRow';
import {TileListSkeleton} from 'views/home/dashboard/tiles/TileListSkeleton';
import {TileScroller} from 'views/home/dashboard/TileScroller';
import {isHomeDirectoryOn} from 'views/home/homeDirectory';

export const NewArrivalsTile = ({state}: {state: DashboardState}) => {
  const bodyRef = useSkeletonFadeIn(state.newArrivalsLoading);
  // When home is the directory, /people redirects back here, so "View all"
  // would go nowhere.
  const homeIsDirectory = isHomeDirectoryOn(useAtomValue(growthbookCacheAtom));
  if (state.newArrivalsLoading) {
    return <TileListSkeleton tileId="newArrivals" />;
  }

  return (
    <Tile
      tileId="newArrivals"
      bodyRef={bodyRef}
      accessory={
        state.newArrivals.length > 0 && !homeIsDirectory ? (
          <TileHeaderLink to={ROUTE_PATHS.PEOPLE} />
        ) : undefined
      }
    >
      <TileScroller>
        {state.newArrivals.map((item) => {
          const shade = withShade({style: {marginInline: -8, cursor: 'pointer'}});
          const href = item.ldap
            ? ROUTE_PATHS.PROFILE.replace(':userid', item.ldap)
            : ROUTE_PATHS.PEOPLE;
          return (
            <TileRowLink key={item.id} to={href}>
              <NewArrivalPersonRow item={item} shade={shade} />
            </TileRowLink>
          );
        })}
      </TileScroller>
    </Tile>
  );
};
